import React from 'react';
import { Row, Col, Glyphicon, Button } from 'react-bootstrap';
import { SortableElement } from 'react-sortable-hoc';
import actions from '../../../../constants/actions';

const GroupItemSortable = SortableElement((props) => {
  const onPressAction = (id, label, hidden, action) => e => {
    props.showModalHandle(id, label, hidden, action);
  }

  const onPressDetail = (id, label) => e => {
    props.onPressDetail(id, label);
  }

  return (
    <Row className="group-row">
      <Col className="group-row-col" sm={12}>
        <div className="group-head-title">
          <h3>{props.value.label}</h3>
          <div className="group-actions-btns">
            <Button onClick={onPressAction(props.value.id, props.value.label, props.value.hidden, actions.edit)}>
              <Glyphicon glyph="pencil" />
            </Button>
            <Button onClick={onPressAction(props.value.id, props.value.label, props.value.hidden, actions.hide)}>
              <Glyphicon
                glyph={(props.value.hidden === 0 ? "eye-open" : "eye-close")}
              />
            </Button>
            <Button onClick={onPressAction(props.value.id, props.value.label, props.value.hidden, actions.delete)}>
              <Glyphicon glyph="trash" />
            </Button>
            <Button onClick={onPressDetail(props.value.id, props.value.label)}>
              <Glyphicon glyph="th-list" />
            </Button>
          </div>
        </div>
        <div className="group-links">
          {
            props.value.links && props.value.links.map((link, index) => (
              <p key={`item-${index}`}>
                {link.label}
              </p>
            ))
          }
        </div>
      </Col>
    </Row>
  )
})

export default GroupItemSortable;


// WEBPACK FOOTER //
// ./src/app/screens/sections/groupsSection/groupItemSortable.js